import { color, opacity, size, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Box } from "../../Box";
export const ContentContainer = styled(Box) `
  & svg:not(.svg-inline--fa) {
    max-width: 100%;
  }

  // reset some styles of FontAwesome's React component, because they are causing layout issues in our use-case
  & svg.svg-inline--fa {
    vertical-align: baseline;
  }

  user-select: none;

  &.withAction {
    cursor: pointer;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: ${opacity.disabled};

    & path {
      color: inherit;
      fill: ${color.background.darker};
    }
  }

  &.focus,
  &:focus-visible {
    position: relative;
    outline: none;

    &:before {
      content: "";
      position: absolute;
      left: -${spacing.base.xs};
      right: -${spacing.base.xs};
      top: -${spacing.base.xs};
      bottom: -${spacing.base.xs};
      border: ${size.border.base.outline} solid ${color.border.input.focused};
      border-radius: ${size.borderRadius};
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudENvbnRhaW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ljb24vc3R5bGVkL0NvbnRlbnRDb250YWluZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLEtBQUssRUFDTCxPQUFPLEVBQ1AsSUFBSSxFQUNKLE9BQU8sR0FDUixNQUFNLGdEQUFnRCxDQUFDO0FBQ3hELE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFFaEMsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7ZUFrQjVCLE9BQU8sQ0FBQyxRQUFROzs7O2NBSWpCLEtBQUssQ0FBQyxVQUFVLENBQUMsTUFBTTs7Ozs7Ozs7Ozs7O2VBWXRCLE9BQU8sQ0FBQyxJQUFJLENBQUMsRUFBRTtnQkFDZCxPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7Y0FDakIsT0FBTyxDQUFDLElBQUksQ0FBQyxFQUFFO2lCQUNaLE9BQU8sQ0FBQyxJQUFJLENBQUMsRUFBRTtnQkFDaEIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxVQUFVLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLE9BQU87dUJBQ3JELElBQUksQ0FBQyxZQUFZOzs7Q0FHdkMsQ0FBQyJ9